import React from 'react';

import { FieldProps } from 'formik';

import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';
import Textarea from './Textarea';

type Props = React.ComponentProps<typeof Textarea> &
    Partial<FieldProps<any>> & {
        required?: boolean;
        name: string;
        value: string;
        onChange: (ev: any) => void;
        autoFocus?: boolean;
        mapNameToLabel?: (name: string) => string;
    };

// @todo Switch to using FormInput inside FormikInput
const FormikTextarea: React.FC<Props> = React.forwardRef(
    ({ field = {}, form = {}, mapNameToLabel = (i) => i, ...props }, ref) => {
        const name = field.name || props.name;
        const error = form.errors && form.errors[name];

        const status = error
            ? 'error'
            : // form.touched[field.name] ? 'success' :
              undefined;

        return (
            <FormGroup itemsSpacing={5}>
                <FieldLabel>
                    {mapNameToLabel(name)} {props.required && '*'}
                </FieldLabel>
                <Textarea
                    ref={ref}
                    style={{ fontSize: '1.6rem' }}
                    placeholder={mapNameToLabel(name)}
                    status={status}
                    {...field}
                    {...props}
                />
                <FieldStatusText status="error">{error}</FieldStatusText>
            </FormGroup>
        );
    }
);

export default FormikTextarea;
